import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = getWebAppBffApiClient()

export function getWebAppBffApiClient({
  path
}: {
  path?: string;
} = {}) {
  const defaultRoot = import.meta.env.VITE_ENV.startsWith('prod') ?  'https://web-api.mediainbox.io' : 'https://web-api-dev.mediainbox.io';

  return createKubbApiClient('web-app-bff', (import.meta.env.VITE_WEB_APP_BFF_API_ROOT || defaultRoot) + (path ? `/${path}` : ''));
}

export default axiosClient;
